// Regional Free Shipping Manager
class RegionalFreeShipping {
  constructor() {
    this.cepInput = null;
    this.calculateButton = null;
    this.shippingModal = null;
    this.currentRegion = null;
    this.regionSettings = this.getRegionSettings();
    this.init();
  }

  // Obter configurações de frete por região do tema
  getRegionSettings() {
    return {
      southeast: {
        nome: 'Sudeste',
        ufs: ['SP', 'RJ', 'MG', 'ES'],
        minimum: parseFloat(window.theme?.settings?.free_shipping_southeast || '129.90') * 100
      },
      south: {
        nome: 'Sul',
        ufs: ['RS', 'SC', 'PR'],
        minimum: parseFloat(window.theme?.settings?.free_shipping_south || '149.90') * 100
      },
      centralWest: {
        nome: 'Centro-Oeste',
        ufs: ['DF', 'GO', 'MT', 'MS'],
        minimum: parseFloat(window.theme?.settings?.free_shipping_central_west || '259.90') * 100
      },
      northeast: {
        nome: 'Nordeste',
        ufs: ['BA', 'SE', 'AL', 'PE', 'PB', 'RN', 'CE', 'PI', 'MA'],
        minimum: parseFloat(window.theme?.settings?.free_shipping_northeast || '199.90') * 100
      },
      north: {
        nome: 'Norte',
        ufs: ['AM', 'RR', 'AP', 'PA', 'TO', 'RO', 'AC'],
        minimum: parseFloat(window.theme?.settings?.free_shipping_north || '199.90') * 100
      }
    };
  }

  // Inicializar o sistema
  init() {
    this.setupEventListeners();
    this.loadStoredCep();
    this.loadStoredCepInInputs();
    this.updateProductPageBar(); // Atualizar barra da página de produto na inicialização
  }

  // Configurar event listeners
  setupEventListeners() {
    // Aguardar o DOM estar pronto
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.bindEvents());
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {
    // Event listener para o botão de calcular frete (funciona em ambos os locais)
    document.addEventListener('click', (e) => {
      if (e.target.matches('.js-button')) {
        e.preventDefault();
        this.handleCalculateShipping(e);
      }
    });

    // Event listener para Enter no campo CEP (funciona em ambos os locais)
    document.addEventListener('keypress', (e) => {
      if (e.target.matches('.js-zip') && e.key === 'Enter') {
        e.preventDefault();
        this.handleCalculateShipping(e);
      }
    });

    // Toh DS: ao trocar o tamanho, a barra do produto passa a somar o preço da variante escolhida.
    document.addEventListener('product:variant-change', (evento) => {
      const variante = evento.detail && evento.detail.variant;
      const barra = document.querySelector('.product-shipping .free-shipping, .thb-product-detail .free-shipping');
      if (!variante || !barra || !barra.dataset.produto) return;
      barra.dataset.produto = String(variante.price);
      barra.dataset.variante = String(variante.id);
      this.updateProductPageBar();
    });

    // Event listener para mudanças no carrinho
    document.addEventListener('cart:updated', () => {
      this.updateFreeShippingBars();
      this.updateProductPageBar(); // Atualizar também a barra da página de produto
    });
  }

  // Carregar CEP armazenado no localStorage
  loadStoredCep() {
    const storedCep = localStorage.getItem('user_cep');
    const storedRegion = localStorage.getItem('user_region');
    
    console.log(`[loadStoredCep] CEP armazenado: ${storedCep}, Região: ${storedRegion}`);
    
    if (storedCep && storedRegion) {
      this.currentRegion = storedRegion;
      console.log(`[loadStoredCep] Região definida: ${this.currentRegion}`);
      this.updateFreeShippingBars();
    }
  }

  // Carregar CEP armazenado e preencher inputs
  loadStoredCepInInputs() {
    const storedCep = localStorage.getItem('user_cep');
    if (storedCep) {
      const formattedCep = this.formatCep(storedCep);
      // Preencher inputs em ambos os locais
      const cepInputs = document.querySelectorAll('.js-zip');
      cepInputs.forEach(input => {
        input.value = formattedCep;
      });
    }
  }

  // Atualizar inputs de CEP com formato
  updateCepInputs(cep) {
    const formattedCep = this.formatCep(cep);
    // Atualizar inputs em ambos os locais
    const cepInputs = document.querySelectorAll('.js-zip');
    cepInputs.forEach(input => {
      input.value = formattedCep;
    });
  }

  // Formatar CEP com traço (00000-000)
  formatCep(cep) {
    const cleanCep = cep.replace(/\D/g, '');
    if (cleanCep.length === 8) {
      return cleanCep.replace(/(\d{5})(\d{3})/, '$1-$2');
    }
    return cleanCep;
  }

  // Manipular cálculo de frete
  async handleCalculateShipping(evento) {
    // A calculadora de onde veio a ação: produto, carrinho lateral ou página do carrinho
    const container = evento?.target?.closest('.shipping-calculator') || document.querySelector('.product-shipping') || document;

    this.cepInput = container.querySelector('.js-zip');
    this.calculateButton = container.querySelector('.js-button');
    this.shippingModal = container.querySelector('.ship-note-toggle__content');

    if (!this.cepInput || !this.calculateButton) {
      console.warn('Elementos do calculador de frete não encontrados');
      return;
    }

    const cep = this.cepInput.value.replace(/\D/g, '');
    
    console.log('CEP digitado:', this.cepInput.value);
    console.log('CEP limpo:', cep);
    console.log('Tamanho do CEP:', cep.length);
    
    // O aviso de CEP inválido e o estado do botão são da calculadora (toh-ds.js); aqui só se atualiza a região da barra.
    if (!cep || cep.length !== 8 || !/^\d{8}$/.test(cep)) return;

    try {
      await this.fetchCepInfo(cep);
    } catch (error) {
      console.error('Erro ao buscar informações do CEP:', error);
    }
  }

  // Buscar informações do CEP via API dos Correios
  async fetchCepInfo(cep) {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();

      if (data.erro) {
        throw new Error('CEP não encontrado');
      }

      const uf = data.uf.toUpperCase();
      const region = this.getRegionByUf(uf);

      if (region) {
        this.currentRegion = region;
        localStorage.setItem('user_cep', cep);
        localStorage.setItem('user_region', region);
        
        this.updateFreeShippingBars();
        this.updateCepInputs(cep);
        this.updateProductPageBar(); // Atualizar barra da página de produto
        this.closeShippingModal();
        
        console.log(`CEP ${cep} - UF: ${uf} - Região: ${region}`);
      } else {
        throw new Error('Região não identificada');
      }

    } catch (error) {
      console.error('Erro na consulta do CEP:', error);
      throw error;
    }
  }

  // Identificar região pela UF
  getRegionByUf(uf) {
    for (const [region, config] of Object.entries(this.regionSettings)) {
      if (config.ufs.includes(uf)) {
        return region;
      }
    }
    return null;
  }

  // Atualizar barras de frete grátis
  async updateFreeShippingBars() {
    if (!this.currentRegion) {
      return;
    }

    const regionConfig = this.regionSettings[this.currentRegion];
    if (!regionConfig) {
      return;
    }

    // Buscar dados atualizados do carrinho
    let cartTotal = 0;
    let itens = [];
    try {
      const response = await fetch('/cart.js');
      const cartData = await response.json();
      cartTotal = cartData.total_price;
      itens = cartData.items;
    } catch (error) {
      console.error('Erro ao buscar dados do carrinho:', error);
      return;
    }

    // Atualizar todas as barras de frete grátis
    const freeShippingBars = document.querySelectorAll('.free-shipping');
    
    freeShippingBars.forEach(bar => {
      this.updateSingleFreeShippingBar(bar, cartTotal, regionConfig.minimum, regionConfig.nome, itens);
    });
  }

  // Produto com frete fixo, na tela ou no carrinho, fica fora da regra do frete grátis: sem régua, só o aviso.
  // Devolve true quando o aviso assumiu; senão, quem chamou desenha a régua normal.
  marcarFreteFixo(bar, itens) {
    const fixos = window.theme?.settings?.frete_fixo || [];
    const textos = window.theme?.settings?.frete_fixo_textos;
    const naTela = fixos.includes(Number(bar.dataset.produtoId));
    const fixo = naTela || (itens || []).some((item) => fixos.includes(item.product_id));
    bar.classList.toggle('free-shipping--fixo', fixo);
    if (fixo) {
      bar.querySelector('.free-shipping--text').textContent = naTela ? textos.produto : textos.carrinho;
      bar.style.display = 'block';
    }
    return fixo;
  }

  // Atualizar uma barra de frete grátis específica
  updateSingleFreeShippingBar(bar, cartTotal, minimum, nome, itens) {
    if (this.marcarFreteFixo(bar, itens)) return;

    // Na página do produto, a barra soma o produto da tela (data-produto, em centavos), se ele não estiver no carrinho.
    // Para calcular o frete, o tema põe o produto no carrinho por um instante: aí ele já está no total.
    if (bar.dataset.produto && !(itens || []).some((i) => String(i.variant_id) === bar.dataset.variante)) {
      cartTotal += Number(bar.dataset.produto);
    }
    // Atualizar atributo data-minimum
    bar.setAttribute('data-minimum', minimum);

    // Calcular porcentagem
    let percentage = 0;
    if (minimum > 0 && cartTotal > 0) {
      percentage = Math.min(cartTotal / minimum, 1);
    }

    // Atualizar texto
    const textElement = bar.querySelector('.free-shipping--text');
    if (textElement) {
      if (cartTotal >= minimum) {
        textElement.innerHTML = `Seu pedido tem frete grátis no ${nome}`;
        textElement.classList.add('progress-bar__message--success');
      } else {
        const remaining = minimum - cartTotal;
        const remainingFormatted = this.formatMoney(remaining);
        textElement.innerHTML = `Faltam <span>${remainingFormatted}</span> para o frete grátis no ${nome}`;
        textElement.classList.remove('progress-bar__message--success');
      }
    }

    // Update the progress bar width
    const percentageElement = bar.querySelector('.free-shipping--percentage');
    if (percentageElement) {
      // Definir tanto a CSS variable quanto o width direto
      bar.style.setProperty('--percentage', percentage);
      // No carrinho lateral a barra cresce por escala (--percentage); mudar a largura também a encolhia duas vezes
      if (!bar.closest('.cart-drawer')) percentageElement.style.width = `${percentage * 100}%`;
      
      console.log(`[updateSingleFreeShippingBar] Barra atualizada: ${percentage * 100}%`);
    }

    // Atualizar visibilidade
    bar.style.display = (cartTotal > 0 && minimum > 0) ? 'block' : 'none';
  }

  // Formatar valor monetário
  formatMoney(amount) {
    const value = (amount / 100).toFixed(2);
    return `R$ ${value.replace('.', ',')}`;
  }

  // Fechar modal de frete
  closeShippingModal() {
    if (this.shippingModal) {
      this.shippingModal.classList.remove('active');
    }
  }

  // Obter valor mínimo atual baseado na região
  getCurrentMinimum() {
    if (!this.currentRegion) {
      return parseFloat(window.theme?.settings?.free_shipping_minimum || '250') * 100;
    }
    
    const regionConfig = this.regionSettings[this.currentRegion];
    return regionConfig ? regionConfig.minimum : parseFloat(window.theme?.settings?.free_shipping_minimum || '250') * 100;
  }

  // Atualizar barra da página de produto especificamente
  async updateProductPageBar() {
    if (!this.currentRegion) {
      return;
    }

    const regionConfig = this.regionSettings[this.currentRegion];
    if (!regionConfig) {
      return;
    }

    // Buscar dados atualizados do carrinho
    let cartTotal = 0;
    let itens = [];
    try {
      const response = await fetch('/cart.js');
      const cartData = await response.json();
      cartTotal = cartData.total_price;
      itens = cartData.items;
    } catch (error) {
      console.error('Erro ao buscar dados do carrinho:', error);
      return;
    }

    // Atualizar APENAS a barra da página de produto
    const productPageBar = document.querySelector('.product-shipping .free-shipping');
    if (productPageBar) {
      console.log(`[updateProductPageBar] Atualizando barra da página de produto - Cart Total: ${cartTotal}, Minimum: ${regionConfig.minimum}`);
      this.updateSingleFreeShippingBar(productPageBar, cartTotal, regionConfig.minimum, regionConfig.nome, itens);
    } else {
      console.log('[updateProductPageBar] Barra da página de produto não encontrada');
    }
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.regionalFreeShipping = new RegionalFreeShipping();
  });
} else {
  window.regionalFreeShipping = new RegionalFreeShipping();
}
